import { getAccessToken } from 'src/utils/sse.utils';
import { API_VERSION } from 'src/constants/api-routes';

export const prepareHeaders = (
  headers: Headers,
  { endpoint }: { getState: () => any; endpoint: string },
): Headers => {
  const access = getAccessToken();
  if (access) headers.set('Authorization', `Bearer ${access}`);
  headers.set('Accept-Language', localStorage.getItem('language') || 'en');
  headers.set('Accept', 'application/json, application/xml, text/plain, text/html, *.*');
  const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;

  const UPLOAD_ENDPOINTS = ['addProjectFile', 'addKnowledgeBaseFile'];
  const WITHOUT_AUTHORIZATION = ['getKnowledgeBaseFileContent'];

  if (!UPLOAD_ENDPOINTS.includes(endpoint)) {
    headers.set('Content-Type', 'application/json; charset=utf-8');
  }

  if (version === API_VERSION.V1 && WITHOUT_AUTHORIZATION.includes(endpoint)) {
    headers.delete('Authorization');
  }

  return headers;
};
